module.exports = __webpack_public_path__ + "assets/img/download-banner1.1c055184.png";